import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Call, Email, Telegram, WhatsApp } from "@mui/icons-material";
import { SpeedDial, SpeedDialAction } from "@mui/material";
import FacebookMessenger from "./assets/svgIcons/FacebookMessenger";
import Viber from "./assets/svgIcons/Viber";
import "./ContactUsBtn.scss";
import { useLocation } from "react-router-dom";

export const ContactUsBtn = ({ isProfileLayout }) => {
  const { t: _t } = useTranslation();

  const location = useLocation();

  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const messengers = [
    { icon: <Email />, name: _t("Email"), href: "mailto:dentalbotapp@gmail.com" },
    { icon: <Telegram />, name: _t("Telegram"), href: "https://t.me/dentalbotapp" },
    { icon: <WhatsApp />, name: _t("WhatsApp"), href: "https://wa.me/380997177136" },
    { icon: <Viber />, name: _t("Viber"), href: "viber://chat?number=%2B380997177136" },
    {
      icon: <FacebookMessenger />,
      name: _t("Facebook messenger"),
      href: "https://www.facebook.com/messages/t/dentalbotapp",
    },
  ];

  if (location.pathname.includes("/preview")) {
    return null;
  }

  return (
    <SpeedDial
      ariaLabel="contact-us-btn"
      className="contact-us-btn"
      icon={<Call />}
      onClose={handleClose}
      onOpen={handleOpen}
      open={open}
    >
      {messengers.map(({ icon, name, action, href }) => (
        <SpeedDialAction
          key={name}
          icon={icon}
          tooltipTitle={name}
          title={name}
          FabProps={action ? {} : { href, target: "_blank", rel: "noopener noreferrer" }}
          onClick={() => {
            action && action();
            handleClose();
          }}
        />
      ))}
    </SpeedDial>
  );
};
